import ContractTemplate from './contract_template.vue';

export default ContractTemplate;
